import { FormArray, FormControl, FormGroup } from '@angular/forms';

export const EMPTY_DATE_TIME = '0001-01-01T00:00:00';

export enum PreferredContactMethod {
  PHONE = 1,
  EMAIL = 2
}

export interface InquiryPreferredSlot {
  dayOfWeek: number | undefined;
  startTime: string;
  endTime: string;
}

export interface InquiryInstrumentPreference {
  instrumentId: number;
  preferredSlots: Array<InquiryPreferredSlot>;
}

export interface SchedulerLessonPreference {
  ageGroup?: number;
  skill?: string;
  lessonType?: boolean;
}

export interface InquiryDependentDetail extends SchedulerLessonPreference {
  inquiryDependentDetailId?: number;
  id?: number;
  isAccountManager?: boolean;
  isChildWithSpecialNeeds?: boolean;
  stage?: number;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  locationId: number;
  typeOfInquiry: number;
  specialNeed: boolean;
  studentClassification: string;
  physicalBehaviour: string;
  isStudentAttendingSchool: boolean;
  typeOfClassroom: string;
  studentLanguageSkills: string;
  goalOfTakingMusicLesson: string;
  instruments: Array<InquiryInstrumentPreference>;
}

export interface InquiryCreatedDependent {
  id: number;
  firstName: string;
  lastName: string;
}

export interface InquiryCreatedResult {
  id: number;
  dependentDetails: Array<InquiryCreatedDependent>;
}

export interface InquiryRequest extends SchedulerLessonPreference {
  id?: number;
  status?: number;
  stage?: number;
  isFromScheduleForm?: boolean;
  isIncompleteData?: boolean;
  isBookingConfirmed?: boolean;
  inquiryDependentDetailId?: number;
  totalTouchCount?: number;
  inquiryCreatedDate: string;
  firstName: string;
  lastName: string;
  emailId: string;
  phoneNo: string;
  dateOfBirth: string;
  locationId: number;
  preferredContactMethod: PreferredContactMethod;
  isPreferredContactTimeAsap: boolean;
  preferredContactDate: string | null;
  preferredContactTimeFrom: string | null;
  preferredContactTimeTo: string | null;
  referenceFrom: string;
  message: string;
  userType: number;
  isDependent: boolean;
  typeOfInquiry: number;
  isChildWithSpecialNeeds: boolean;
  studentClassification: string;
  physicalBehaviour: string;
  isStudentAttendingSchool: boolean;
  typeOfClassroom: string;
  studentLanguageSkills: string;
  goalOfTakingMusicLesson: string;
  instruments: Array<InquiryInstrumentPreference>;
  dependentDetails: Array<InquiryDependentDetail>;
}

export interface InquiryPreferredSlotForm {
  dayOfWeek: FormControl<number | undefined>;
  startTime: FormControl<string>;
  endTime: FormControl<string>;
}

export interface InquiryInstrumentForm {
  instrumentId: FormControl<number | undefined>;
  preferredSlots: FormArray<FormGroup<InquiryPreferredSlotForm>>;
}

export interface InquiryDependentForm {
  inquiryDependentDetailId: FormControl<number | undefined>;
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  dateOfBirth: FormControl<string>;
  locationId: FormControl<number | undefined>;
  typeOfInquiry: FormControl<number | undefined>;
  isSpecialNeeds: FormControl<boolean>;
  studentClassification: FormControl<string>;
  physicalBehaviour: FormControl<string>;
  isStudentAttendingSchool: FormControl<boolean>;
  typeOfClassroom: FormControl<string>;
  studentLanguageSkills: FormControl<string>;
  goalOfTakingMusicLesson: FormControl<string>;
  instruments: FormArray<FormGroup<InquiryInstrumentForm>>;
}

export interface InquiryFormGroupType {
  inquiryDependentDetailId: FormControl<number | undefined>;
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  emailId: FormControl<string>;
  phoneNo: FormControl<string>;
  dateOfBirth: FormControl<string>;
  locationId: FormControl<number | undefined>;
  preferredContactMethod: FormControl<PreferredContactMethod | undefined>;
  isPreferredContactTimeAsap: FormControl<boolean>;
  preferredContactDate: FormControl<string>;
  preferredContactTimeFrom: FormControl<string>;
  preferredContactTimeTo: FormControl<string>;
  dependentId: FormControl<number | undefined>;
  typeOfInquiry: FormControl<number | undefined>;
  referenceFrom: FormControl<string>;
  message: FormControl<string>;
  dependentDetails: FormArray<FormGroup<InquiryDependentForm>>;
  isSpecialNeeds: FormControl<boolean>;
  studentClassification: FormControl<string>;
  physicalBehaviour: FormControl<string>;
  isStudentAttendingSchool: FormControl<boolean>;
  typeOfClassroom: FormControl<string>;
  studentLanguageSkills: FormControl<string>;
  goalOfTakingMusicLesson: FormControl<string>;
  instruments: FormArray<FormGroup<InquiryInstrumentForm>>;
}
